import { IsNotEmpty, IsNumber, IsOneOfThese, IsValidDate } from '@core/services/csv/CSVCustomValidator'
import { CSVModelInterface } from '@core/services/csv/CSVModel.interface'
import { DateService } from '@master/services/DateService'
import { CommissionData } from '../../api'
import { Expose, Transform } from 'class-transformer'
import { ValidateIf } from 'class-validator'
import { isEmpty } from 'lodash'
import { parseFloatNumber, parseIntNumber } from '@core/services/csv/CSVTransformer'
import { FrequencyList, FrequencyToValueMapping, FrequencyType } from '@master/model/options/FrequencyOptions'
import { productTypes } from '@master/model/options/LineOfBusinessOptions'

const dateService = new DateService()

export class NTUCTransactionCsvModel extends CSVModelInterface implements CommissionData {
  @Expose()
  @IsNotEmpty()
  private 'Agent Code' = 'CODE 123'

  get advCode () {
    return this['Agent Code']
  }

  @Expose()
  private 'Agent Name' = 'Wen Adviser'

  get advName () {
    return this['Agent Name']
  }

  @Expose()
  @IsNotEmpty()
  private 'Policy No.' = 'Policy 123'

  get policyNumber () {
    return this['Policy No.']
  }

  @Expose()
  private 'Name' = 'John Doe'

  get clientName () {
    return this.Name
  }

  @Expose()
  private 'DN/CN NO.' = 'S00123'

  get clientNric () {
    return this['DN/CN NO.']
  }

  @Expose()
  private 'Plan' = 'PL001'

  get planCode () {
    return this.Plan
  }

  private 'ComponentCode' = undefined

  get componentCode () {
    return this.ComponentCode
  }

  private 'PlanDescription' = undefined

  get productName () {
    return this.PlanDescription
  }

  @Expose()
  @IsNotEmpty()
  @IsOneOfThese(productTypes)
  private 'Product Type' = '[' + productTypes + ']'

  get productType () {
    return this['Product Type']
  }

  @Expose()
  @ValidateIf(o => !isEmpty(o.premiumCurrency))
  @IsOneOfThese(['SGD', 'CHF', 'EUR', 'GBP', 'USD', 'AUD', 'JPY', 'HKD'])
  private 'Premium Currency' = 'SGD'

  get premiumCurrency () {
    return this['Premium Currency']
  }

  @Expose()
  @Transform(({ value }) => parseFloatNumber(value))
  @IsNumber()
  private 'Premium' = 123.45

  get premiumAmt () {
    return this.Premium
  }

  @Expose()
  @IsOneOfThese(FrequencyList.filter(frequency => !['RSP', 'Single'].includes(frequency)))
  private 'Pay Mode' = 'Monthly'

  get payMode () {
    return FrequencyToValueMapping(this['Pay Mode'] as FrequencyType)
  }

  @Expose()
  @Transform(({ value }) => parseFloatNumber(value))
  @ValidateIf(o => !isEmpty(o.exchangeRate))
  @IsNumber()
  private 'Exchange Rate' = 123.45

  get exchangeRate () {
    return this['Exchange Rate']
  }

  @Expose()
  @Transform(({ value }) => parseIntNumber(value))
  @ValidateIf(o => !isEmpty(o.policyYear))
  @IsNumber()
  private 'Policy Year' = 13

  get policyYear () {
    return this['Policy Year']
  }

  @Expose()
  @ValidateIf(o => !isEmpty(o.approvedDate))
  @IsValidDate('DD/MM/YYYY')
  private 'Entry Date' = '31/12/2020'

  get approvedDate (): number {
    return dateService.toUnixMilliseconds(this['Entry Date'], 'DD/MM/YYYY')
  }

  @Expose()
  @ValidateIf(o => !isEmpty(o.paidToDate))
  @IsValidDate('DD/MM/YYYY')
  private 'Due Date' = '31/12/2020'

  get paidToDate (): number {
    return dateService.toUnixMilliseconds(this['Due Date'], 'DD/MM/YYYY')
  }

  @Expose()
  private 'Commission Amount (in Foreign Currency)' = 'IDR'

  get commissionForeignCurrency () {
    return this['Commission Amount (in Foreign Currency)']
  }

  @Expose()
  private 'Commission Payable (in SGD)' = 0

  get commissionAmt () {
    return this['Commission Payable (in SGD)']
  }

  private 'OrComm' = 0

  get orCommissionAmt () {
    return this.OrComm
  }

  @Expose()
  private 'Premiumtype' = 'Renewal'

  get descriptions () {
    return this.Premiumtype
  }
}
